//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import {
  ITrackingParamGroup,
  ITrackingParamsResponse,
} from '@legacy-components/common/universal-image-actions/universal-image-actions-api-service';
import { ICuralateStore } from '@models/AppState';
import { createSelector } from 'reselect';

export const getTrackingParamsGroupWithDefault = (
  paramSettings: ITrackingParamsResponse | undefined,
  groupId: string,
) =>
  getTrackingParamsGroup(paramSettings, groupId) ??
  ({ id: groupId, inUse: true, params: [] } as ITrackingParamGroup);

export const getTrackingParamsGroup = (
  paramSettings: ITrackingParamsResponse | undefined,
  groupId: string,
) =>
  paramSettings?.trackingParams?.paramGroups.find(
    (group) => group.id === groupId,
  );

export const getGoogleTrackingParamsGroup = createSelector(
  (state: ICuralateStore) => state.accountSettings.trackingParams.settings,
  (paramSettings) => getTrackingParamsGroup(paramSettings, 'google'),
);

export const getCustomTrackingParamsGroup = createSelector(
  (state: ICuralateStore) => state.accountSettings.trackingParams.settings,
  (paramSettings) => getTrackingParamsGroup(paramSettings, 'custom'),
);

export const getReservedGoogleParam = createSelector(
  getGoogleTrackingParamsGroup,
  (googleParamGroup) =>
    googleParamGroup?.params.find((param) => param.curalateReserved),
);

export const getReferralGoogleParam = createSelector(
  getGoogleTrackingParamsGroup,
  (googleParamGroup) => googleParamGroup?.params.find((param) => param.autoSet),
);
